// extracted by mini-css-extract-plugin
export default {"card":"AgreementForm_card__4hrbI","body":"AgreementForm_body__Elj00","button":"AgreementForm_button__040u8","inputsContainer":"AgreementForm_inputsContainer__AcEPS"};